/*
 * @Description: 一些常用的类型定义
 * @Author: kadenwang@tencent.com
 * @Date: 2021-11-16 21:34:16
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2022-03-28 21:47:01
 */

export enum ILoginStateCode {
  'USER_LOGIN_SUCCESS' = 0,
  'USER_LOGIN_FAILED' = 1,
  'USER_LOGOUT' = 2,
  'USER_INFO_CHANGE' = 3,
  'USER_BIND_MAIL_SUCCESS' = 4,
}

export enum ILoginType {
  gg = 'gg',
  fb = 'fb',
  QC = 'QC',
  WX = 'WX'
}

export interface IUserInfo {
  /** 用户头像 **/
  profilePhoto: string;
  /** 绑定的邮箱 **/
  userBindMail: string;
  /** 用户名 **/
  username: string;
  /** 登陆类型 gg: google fb: facebook WX: 微信 QC: QQ **/
  loginType: ILoginType;
  /** 账号注册地区名字 **/
  accountRegionName: string;
  /** 账号注册地区 ID **/
  accountRegionId: string;
  /** 账号注册邮箱 **/
  accountMail: string;
  /** accessToken */
  accessToken: string;
  /** openId */
  openId: string;
  /** 昵称 */
  nickname: string;
  /** 市场的 area */
  area?: string;
  /** 用户ID */
  userId: string;
}
export interface ILoginStateChange {
  code: ILoginStateCode;
  info: IUserInfo | null;
}

export interface ILoginButton {
  LoginStateChangeCallBack: (info: ILoginStateChange) => void;
}

export interface TokenInfo {
  code: string;
  access_token: string;
  token_expire_in: string;
  refresh_token: string;
}

export interface Userinfo {
  user_id: string;
  open_id: string;
  name: string;
  picture_url: string;
  email: string;
  login_type: ILoginType;
  register_country_code: string;
  date_of_birth: string;
  register_country_name: string;
  userBindMail: string;
  area: string;
}

export interface ICheckUserInfoData {
  token_info: TokenInfo;
  userinfo: Userinfo;
}

export interface ICheckUserInfo {
  status_code: number;
  msg: string;
  data: ICheckUserInfoData;
}

export interface IPrepareNotice {
  stateCode: ILoginStateCode;
  userInfo: ICheckUserInfoData;
  needPullEmail?: boolean;
}
